import { createAction } from "@reduxjs/toolkit";

// Define Action Types for OEQ
export const ACTION_TYPES = {
  UPDATE_OEQ: "UPDATE_OEQ",
  SUBMIT_OEQ: "SUBMIT_OEQ",
};

// Define action creators using createAction
export const updateOEQ = createAction(ACTION_TYPES.UPDATE_OEQ, (data) => ({
  payload: data,
}));

export const submitOEQ = createAction(
  ACTION_TYPES.SUBMIT_OEQ,
  (componentID) => ({ payload: componentID })
);
